import React from 'react'
import PropTypes from 'prop-types'
import StandardContainer from '../StandardContainer'
// import styles from './StandardBody.module.scss'

export const StandardBody = ({ children }) => (
  <StandardContainer>
    <main>
      {children}
    </main>
  </StandardContainer>
)

StandardBody.propTypes = {
  children: PropTypes.node,
}
